const $searchContainer = document.querySelector("[data-search-container]");

if ($searchContainer) {
  /* eslint-disable-next-line no-unused-expressions */
  import("./app");
}
